
import {ElLoading} from "element-plus";

const columnList: Array<column> = [
    {
        prop: "dpname",
        label: "部门",
        width: 51,
    },
    {
        prop: "provalue",
        label: "项目产值",
        width: 51,
    },
    {
        prop: "accevalue",
        label: "配件产值",
        width: 51,
    },
    {
        prop: "totalvalue",
        label: "总产值",
        width: 51,
    },
    {
        prop: "income",
        label: "手动记账收入",
        width: 51,
    },
    {
        prop: "salesman_name",
        label: "代收手续费",
        width: 51,
    },
    {
        prop: "profit_value",
        label: "配件销售利润",
        width: 51,
    },

    {
        prop: "totalincome",
        label: "总收入",
        width: 51,
    },
    {
        prop: "valuecost",
        label: "配件成本",
        width: 51,
    },
    {
        prop: "whrecord",
        label: "辅料成本",
        width: 51,
    },
    {
        prop: "othercosts",
        label: "其它成本",
        width: 51,
    },
    {
        prop: "givecosts",
        label: "赠送成本",
        width: 51,
    },
    {
        prop: "totallinecost",
        label: "成本小计",
        width: 51,
    },
    {
        prop: "expenditure",
        label: "手动记账支出",
        width: 51,
    },
    {
        prop: "sell_commission",
        label: "推荐返现",
        width: 51,
    },
    {
        prop: "fixed",
        label: "固定资产折旧",
        width: 51,
    },
    {
        prop: "baddebt",
        label: "坏账",
        width: 51,
    },
    {
        prop: "totalcost",
        label: "总成本",
        width: 51,
    },
    {
        prop: "grossprofit",
        label: "毛利",
        width: 51,
    },
    {
        prop: "grossmargin",
        label: "毛利率",
        width: 51,
    },
    {
        prop: "netprofit",
        label: "净利",
        width: 51,
    },
    {
        prop: "interestrate",
        label: "净利率",
        width: 51,
    },
];
// 项目产值
const projectColumn: Array<column> = [
    {
        prop: "order_sn",
        label: "工单号",
        width: 95,
    },
    {
        prop: "settlement_time_text",
        label: "结算时间",
        width: 95,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 95,
    },
    {
        prop: "car_name",
        label: "车型",
        width: 95,
    },
    {
        prop: "name",
        label: "项目",
        width: 95,
    },
    {
        prop: "construct_name",
        label: "施工人",
        width: 95,
    },
    {
        prop: "offer_price",
        label: "报价金额",
        width: 95,
    },
    {
        prop: "output_value",
        label: "销售金额",
        width: 95,
    },
    {
        prop: "build_num",
        label: "施工人数",
        width: 95,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 95,
    },
];
// 配件产值
const partsOutputValueColumn: Array<column> = [
    {
        prop: "order_sn",
        label: "工单号",
        width: 73,
    },
    {
        prop: "settlement_time_text",
        label: "结算时间",
        width: 73,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 73,
    },
    {
        prop: "car_name",
        label: "车型",
        width: 73,
    },
    {
        prop: "name",
        label: "配件",
        width: 73,
    },

    {
        prop: "construct_name",
        label: "施工人",
        width: 73,
    },
    {
        prop: "offer_price",
        label: "报价",
        width: 73,
    },
    {
        prop: "sell_price",
        label: "销售价",
        width: 73,
    },
    {
        prop: "num",
        label: "数量",
        width: 73,
    },
    {
        prop: "sum_offer_price",
        label: "报价金额",
        width: 73,
    },
    {
        prop: "output_value",
        label: "销售金额",
        width: 73,
    },
    {
        prop: "build_num",
        label: "施工人数",
        width: 73,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 73,
    },
];
// 手动记账收入
const bookkeepingColumn: Array<column> = [
    {
        prop: "income_time_text",
        label: "收入日期",
        width: 95,
    },
    {
        prop: "income_collection_text",
        label: "收入类型",
        width: 95,
    },
    {
        prop: "ordersn",
        label: "关联单据",
        width: 95,
    },
    {
        prop: "create_time_text",
        label: "创建时间",
        width: 95,
    },
    {
        prop: "income_price",
        label: "金额",
        width: 95,
    },
    {
        prop: "income_type_text",
        label: "收款方式",
        width: 95,
    },
    {
        prop: "income_payer",
        label: "付款方",
        width: 95,
    },
    {
        prop: "admin",
        label: "经手人",
        width: 95,
    },
    {
        prop: "income_desc",
        label: "备注",
        width: 95,
    },
];
// 配件销售利润
const partsSellColumn: Array<column> = [
    {
        prop: "partsSale_ordersn",
        label: "单据编号",
        width: 136,
    },
    {
        prop: "parts_sale_settement_time_text",
        label: "结算时间",
        width: 136,
    },
    {
        prop: "partsSale_name",
        label: "客户姓名",
        width: 136,
    },
    {
        prop: "partsSale_phone",
        label: "客户手机",
        width: 136,
    },
    {
        prop: "total_price",
        label: "金额",
        width: 136,
    },
    {
        prop: "total_profit",
        label: "利润",
        width: 136,
    },
    {
        prop: "partsSale_desc",
        label: "备注",
        width: 136,
    },
];
// 配件成本-领料退料配件
const receivePartsColumn: Array<column> = [
    {
        prop: "record_code",
        label: "单据编号",
        width: 79,
    },
    {
        prop: "reviewer_time_text",
        label: "审核时间",
        width: 79,
    },
    {
        prop: "type",
        label: "类型",
        width: 79,
    },
    {
        prop: "car_name",
        label: "车牌号",
        width: 79,
    },
    {
        prop: "settlement_time_text",
        label: "结算时间",
        width: 79,
    },

    {
        prop: "parts_name",
        label: "配件",
        width: 79,
    },
    {
        prop: "specification",
        label: "规格",
        width: 79,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 79,
    },
    {
        prop: "takeaway_text",
        label: "领料人",
        width: 79,
    },
    {
        prop: "price",
        label: "成本价",
        width: 79,
    },
    {
        prop: "number",
        label: "数量",
        width: 79,
    },
    {
        prop: "total_price",
        label: "成本",
        width: 79,
    },
];
// 配件成本-临时配件自动采购
const temporaryPartsColumn: Array<column> = [
    {
        prop: "ordersn",
        label: "单据编号",
        width: 95,
    },
    {
        prop: "settlement_time_text",
        label: "审核时间",
        width: 95,
    },
    {
        prop: "model_name",
        label: "车牌号",
        width: 95,
    },
    {
        prop: "mountings_name",
        label: "结算时间",
        width: 95,
    },

    {
        prop: "salesman_name",
        label: "配件",
        width: 95,
    },
    {
        prop: "reference_price",
        label: "规格",
        width: 95,
    },
    {
        prop: "reference_price",
        label: "编码",
        width: 95,
    },
    {
        prop: "reference_price",
        label: "成本价",
        width: 95,
    },
    {
        prop: "reference_price",
        label: "数量",
        width: 95,
    },
    {
        prop: "reference_price",
        label: "成本",
        width: 95,
    },
];
// 赠送成本
const giveCostColumn: Array<column> = [
    {
        prop: "ordersn",
        label: "单据编号",
        width: 95,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 95,
    },
    {
        prop: "settlement_time",
        label: "结算时间",
        width: 95,
    },
    
    {
        prop: "project_name",
        label: "赠送项目",
        width: 95,
    },
    {
        prop: "cost_price",
        label: "成本",
        width: 95,
    }
];
// 其他成本
const otherCostColumn: Array<column> = [
    {
        prop: "ordersn",
        label: "单据编号",
        width: 95,
    },
    {
        prop: "settlement_time",
        label: "结算时间",
        width: 95,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 95,
    },
    {
        prop: "othercosts_name",
        label: "成本项目",
        width: 95,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 95,
    },
    {
        prop: "othercosts_costprice",
        label: "成本",
        width: 95,
    }
];
// 辅料成本
const materialsColumn: Array<column> = [
    {
        prop: "record_code",
        label: "单据编号",
        width: 95,
    },
    {
        prop: "settlement_time_text",
        label: "审核时间",
        width: 95,
    },
    {
        prop: "type",
        label: "类型",
        width: 95,
    },
    {
        prop: "model_name",
        label: "车牌号",
        width: 95,
    },
    {
        prop: "mountings_name",
        label: "结算时间",
        width: 95,
    },

    {
        prop: "parts_name",
        label: "配件",
        width: 95,
    },
    {
        prop: "specification",
        label: "规格",
        width: 95,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 95,
    },
    {
        prop: "takeaway_text",
        label: "领料人",
        width: 95,
    },
    {
        prop: "price",
        label: "成本价",
        width: 95,
    },
    {
        prop: "number",
        label: "数量",
        width: 95,
    },
    {
        prop: "total_price",
        label: "成本",
        width: 95,
    },
];
// 手动记账支出
const bookkeepingPayColumn: Array<column> = [
    {
        prop: "expenditure_time_text",
        label: "支出日期",
        width: 95,
    },
    {
        prop: "expenditure_type",
        label: "支出类型",
        width: 95,
    },
    {
        prop: "ordersn",
        label: "关联单据",
        width: 95,
    },
    {
        prop: "create_time_text",
        label: "创建时间",
        width: 95,
    },
    {
        prop: "expenditure_price",
        label: "金额",
        width: 95,
    },
    {
        prop: "pay_type_text",
        label: "付款方式",
        width: 95,
    },
    {
        prop: "expenditure_payer",
        label: "收款方",
        width: 95,
    },
    {
        prop: "admin",
        label: "经手人",
        width: 95,
    },
    {
        prop: "expenditure_desc",
        label: "备注",
        width: 95,
    },
];
// 固定资产折旧
const assetsColumn: Array<column> = [
    {
        prop: "fixed_name",
        label: "资产名称",
        width: 95,
    },
    {
        prop: "fixed_price",
        label: "价值",
        width: 95,
    },
    {
        prop: "yue",
        label: "折旧月数",
        width: 95,
    },
    {
        prop: "Term",
        label: "折旧期限",
        width: 95,
    },

    {
        prop: "fixed_type",
        label: "类型",
        width: 95,
    },
    {
        prop: "create_time_text",
        label: "创建时间",
        width: 95,
    },
    {
        prop: "reference_price",
        label: "折旧月份",
        width: 95,
    },
    {
        prop: "price",
        label: "折旧金额",
        width: 95,
    },
];
// 坏账
const badDebtColumn: Array<column> = [
    {
        prop: "ordersn",
        label: "单据编号",
        width: 95,
    },
    {
        prop: "settlement_time_text",
        label: "结算时间",
        width: 95,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 95,
    },
    {
        prop: "order_message_text",
        label: "接车人",
        width: 95,
    },

    {
        prop: "basicset_name",
        label: "服务类型",
        width: 95,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 95,
    },
    {
        prop: "order_message_give_text",
        label: "送修人",
        width: 95,
    },
    {
        prop: "order_offer_price",
        label: "报价金额",
        width: 95,
    },
    {
        prop: "price",
        label: "结算金额",
        width: 95,
    },
    {
        prop: "return_price",
        label: "坏账",
        width: 95,
    },
];
import { Request } from "@/api/request";
import { accAdd } from "@/api/api";
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
    computed,
} from "vue";
import {
    getFixedList,
    getOutputValueList,
    getPartsSaleProfit,
    getPurchaseTable,
    getSupplierList, getWhRecordList, gteExpenditureList,
    gteIncomeList,
    purchaseCopeExport,
    getGiveCostList,
    getOtherCostsList,
    getBaddebtList,
    totalExport
} from "@/api/http";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "ProfitSummary",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["部门利润汇总"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            totalData = reactive({} as any),
            total = ref(0),
            dialogData = reactive({
                tableData:[],
                page:1,
                pageSize:10,
                total:0,
                currentId:0,
                currentProperty:""
            }),
            handleSizeChange = (value: number): void => {
                dialogData.pageSize = value;
                getCommonData(dialogData.currentId,dialogData.currentProperty);
            },
            handleCurrentChange = (pageSize: number): void => {
                dialogData.page = pageSize;
                getCommonData(dialogData.currentId,dialogData.currentProperty);
            },
            loading = ref(true),
            headClass = inject("headClass"),
            // getNow = ():number => {
            //   //let now = Date.parse(new Date().toString());
            //   let now = new Date().getTime()/1000;
            //   console.log('现在时间---',now);
            //   return now;
            // },
            getFirstNowLastDay = ():Array<number> => {
              let now = new Date();
              let strLink = "/";
              let year = now.getFullYear();
              let month:any = now.getMonth() + 1;
              let day:any = now.getDate();
              // if (month >= 1 && month <= 9) {
              //   month = "0" + month;
              // }
              // if (day >= 1 && day <= 9) {
              //   day = "0" + day;
              // }
              let firstDate:string = year + strLink + month + strLink + '1';
              let currentDate = year + strLink + month + strLink + day;
              //var lastDay = this.getLastDay(year, month);
              //var lastDate = year + strLink + month + strLink + lastDay;
              return [new Date(firstDate).getTime(),new Date(currentDate).getTime()];
            },
            screenParameter = reactive({
                start_date: getFirstNowLastDay()[0],
                end_date: getFirstNowLastDay()[1],
              date_array:[getFirstNowLastDay()[0],getFirstNowLastDay()[1]]
            }),

            screenChange = (e: any, key: any): void => {
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let start_time = screenParameter.date_array?Math.floor(new Date(screenParameter.date_array[0]).getTime()/1000):"";
              let end_time = screenParameter.date_array ?Math.floor((new Date(screenParameter.date_array[1]).getTime()+24*60*60*1000-1)/1000):"";
                let data = {start_time:start_time,end_time:end_time};
                Request.axiosInstance({
                    url: "adminapi/BranchSummary/list",
                    data,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    totalData = res.content.totals;
                    console.log('---',totalData);
                });
            },
            selectChange = (e: number): void => {
                // console.log(e);
                getTableData();
            };
        let cellIndex: Array<number> = [1, 2, 4, 6, 8, 9,10,11, 13, 15, 16],
            // 单元格样式替换
            setCellColor = ({columnIndex,}: { columnIndex: Number; }): string => {
                if (cellIndex.find((item) => item == columnIndex)) {
                    return "color-red";
                }
                return "";
            },
            dialogTitle = ref([
                "项目产值",
                "配件产值",
                "手动记账收入",
                "配件销售利润",
                "配件成本",
                "辅料成本",
                "手动记账支出",
                "固定资产折旧",
                "坏账",
                "赠送成本",
                "其它成本"
            ] as Array<String>),
            dialogType = ref(-1),
            // 单元格点击事件
            cellClick = (row: any, column: any): void => {
                console.log("点击的行是--",row);
                console.log("点击的lie是--",column);
                dialogType.value = dialogTitle.value.findIndex(
                    (item) => item == column.label
                );
                console.log("点击的弹窗是",dialogType.value );
                dialogData.currentId = row.id;
                dialogData.currentProperty = column.property;
                dialogData.page = 1;
                dialogData.pageSize = 10;
                dialogData.tableData = [];
                dialogData.total = 0;
                if (cellIndex.indexOf(column.rawColumnKey)!=-1){
                    loading.value = true;
                }
                getCommonData(dialogData.currentId,dialogData.currentProperty);
                //dialogData.tableData = row.profit_value.list;
                
            },
            getCommonData = ((id:any,property:string)=>{
                let start_time = screenParameter.date_array?Math.floor(new Date(screenParameter.date_array[0]).getTime()/1000):"";
                let end_time = screenParameter.date_array ?Math.floor((new Date(screenParameter.date_array[1]).getTime()+24*60*60*1000-1)/1000):"";
                let data = {
                    start_time:start_time,
                    end_time:end_time,
                    page:dialogData.page,
                    pagesize:dialogData.pageSize
                };
                if (property=="profit_value"){//配件销售利润
                    if (id==0){
                        getPartsSaleProfit(data).then((res: any) => {
                            loading.value = false;
                            dialogData.tableData = res.content.list;
                            dialogData.total = res.content.total;
                        });
                    }else {
                        loading.value = false;
                    }
                    
                }
                if (property=="income"){//手动记账收入
                    if (id==0){
                        gteIncomeList({...data,type:1,income_status:2}).then((res: any) => {
                            loading.value = false;
                            dialogData.tableData = res.content.list;
                            dialogData.total = res.content.total;
                        });
                    }else {
                        loading.value = false;
                    }
                }
                if (property=="expenditure"){//手动记账支出
                    gteExpenditureList({...data,type:1,expenditure_status:2,branch_id:id}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                    });
                }
                if (property=="provalue"){//项目产值
                    getOutputValueList({...data,type:1,branch_id:id}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                    });
                }
                if (property=="accevalue"){//配件产值
                    getOutputValueList({...data,type:2,branch_id:id}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                    });
                }
                if (property=="whrecord"){//辅料成本
                    getWhRecordList({...data,type:3,branch_id:id}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                        
                    });
                }
                if (property=="valuecost"){//配件成本
                    getWhRecordList({...data,type:1,branch_id:id}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                        
                    });
                }
                if (property=="givecosts"){//赠送成本
                    getGiveCostList({...data,type:1,branch_id:id}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                    });
                }
                if (property=="othercosts"){//其他成本
                    getOtherCostsList({...data,type:1,branch_id:id}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                    });
                }
                if (property=="baddebt"){//坏账
                    getBaddebtList({...data,type:1}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                    });
                }
                if (property=="fixed"){//固定资产列表
                    getFixedList({...data,type:1,branch_id:id}).then((res: any)=>{
                        loading.value = false;
                        dialogData.tableData = res.content.list;
                        dialogData.total = res.content.total;
                        
                    });
                }
            }),
            dialogColumn = [
                projectColumn,
                partsOutputValueColumn,
                bookkeepingColumn,
                partsSellColumn,
                receivePartsColumn,
                materialsColumn,
                bookkeepingPayColumn,
                assetsColumn,
                badDebtColumn,
                giveCostColumn,
                otherCostColumn
            ],
            dialogTableData = computed(() => {
                return {
                    tableData: [],
                    columnList: dialogColumn[dialogType.value],
                };
            }),
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                let start_time = screenParameter.date_array?Math.floor(new Date(screenParameter.date_array[0]).getTime()/1000):"";
                let end_time = screenParameter.date_array ?Math.floor((new Date(screenParameter.date_array[1]).getTime()+24*60*60*1000-1)/1000):"";
                let data = {start_time:start_time,end_time:end_time};
                totalExport(data).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            getSummaries = (param: any): any => {
                const { columns, data } = param;
                const sums: any = [];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    if (column.property=='provalue'){
                        sums[index] = totalData.provalue;
                    }
                    if (column.property=='givecosts'){
                        sums[index] = totalData.givecosts;
                    }
                    if (column.property=='accevalue'){
                        sums[index] = totalData.accevalue;
                    }
                    if (column.property=='totalvalue'){
                        sums[index] = totalData.totalvalue;
                    }
                    if (column.property=='income'){
                        sums[index] = totalData.income;
                    }
                    if (column.property=='profit_value'){
                        sums[index] = totalData.profit_value;
                    }
                    if (column.property=='totalincome'){
                        sums[index] = totalData.totalincome;
                    }
                    if (column.property=='valuecost'){
                        sums[index] = totalData.valuecost;
                    }
                    if (column.property=='whrecord'){
                        sums[index] = totalData.whrecord;
                    }
                    if (column.property=='othercosts'){
                        sums[index] = totalData.othercosts;
                    }
                    if (column.property=='totallinecost'){
                        sums[index] = totalData.totallinecost;
                    }
                    if (column.property=='expenditure'){
                        sums[index] = totalData.expenditure;
                    }
                    if (column.property=='fixed'){
                        sums[index] = totalData.fixed;
                    }
                    if (column.property=='baddebt'){
                        sums[index] = totalData.baddebt;
                    }
                    if (column.property=='totalcost'){
                        sums[index] = totalData.totalcost;
                    }
                    if (column.property=='grossprofit'){
                        sums[index] = totalData.grossprofit;
                    }
                    if (column.property=='grossmargin'){
                        sums[index] = totalData.grossmargin;
                    }
                    if (column.property=='netprofit'){
                        sums[index] = totalData.netprofit;
                    }
                    if (column.property=='interestrate'){
                        sums[index] = totalData.interestrate;
                    }
                });

                return sums;
            };

        onMounted(() => {
            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            screen,
            screenParameter,
            selectChange,
            screenChange,
            setCellColor,
            dialogTitle,
            dialogType,
            cellClick,
            dialogTableData,
            total,
            getSummaries,
            exportChange,
            dialogData,
            handleCurrentChange,
            handleSizeChange,
            totalData
        };
    },
});
